import * as React from 'react';
import { Field } from 'redux-form';

import { Button } from '@acceligentllc/storybook';

import Dropdown from 'af-fields/Dropdown';

import styles from './styles.module.scss';

export interface MaterialGroupOption {
	id: string;
	label: string;
}

interface OwnProps {
	name: string;
	groups: MaterialGroupOption[];
	selectedGroups: Record<string, true>;
	onRemove: (index: number) => void;
	index: number;
}

type Props = OwnProps;

const MaterialGroupInput: React.FC<Props> = (props) => {
	const { name, groups, onRemove, index, selectedGroups } = props;

	const handleRemove = React.useCallback(() => {
		onRemove(index);
	}, [index, onRemove]);

	const filterOptions = React.useCallback((group: MaterialGroupOption) => !selectedGroups[group.id], [selectedGroups]);

	return (
		<div className={styles.MaterialGroupInput}>
			<Field
				className={styles.input}
				component={Dropdown}
				filterOptions={filterOptions}
				labelKey="label"
				name={name}
				options={groups}
				placeholder="Select Group"
				valueKey="id"
				withCaret={true}
			/>
			<Button
				customStyleClass={styles.removeControl}
				icon="Delete"
				onClick={handleRemove}
				style="link-danger"
			/>
		</div>
	);
};

export default React.memo(MaterialGroupInput);
